define('bindingHandlers/loadIndicator',[
    'lib/knockout',
    'jquery'
], function (ko, $) {
    'use strict';
    // Yes, it's a bit ugly - each div is a spoke in the animation wheel.
    // See the style guide for implementation details
    var LOADER_CONTENT_MARKUP = '<div class="load-indicator load-indicator-flex load-indicator-md"><i class="pc-icon-comet fa fa-spin"></i></div>';

    ko.bindingHandlers.loadIndicator = {
        init: function (element, valueAccessor) {
            var isLoading = ko.unwrap(valueAccessor());

            $(element)
                .append(LOADER_CONTENT_MARKUP)
                .toggle(isLoading);
        },
        update: function (element, valueAccessor) {
            var isLoading = ko.unwrap(valueAccessor());
            $(element).toggle(isLoading);
        }
    };

});

